import React from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Box,
  FileUploadButton,
  FormControl,
} from '@tenancy.nz/design-system';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

function UploadButton({
  children,
  errorMessage,
  files,
  name,
  onRemove,
  onUpload,
  helperText,
  ...rest
}) {
  const handleUpload = acceptedFiles => {
    const filtered = [...files, ...acceptedFiles].filter((_, i) => i < 3);
    onUpload(filtered);
  };
  return (
    <Box>
      <FormControl
        name={`${name}_control`}
        helperTextPlacement="below"
        helperText={helperText}
        errorMessage={errorMessage}
        showError={!!errorMessage}>
        <FileUploadButton
          name={name}
          color="primary"
          startIcon={<CloudUploadIcon />}
          disabled={!!rest.maxFiles && files.length >= rest.maxFiles}
          {...rest}
          onUpload={handleUpload}>
          {children}
        </FileUploadButton>
      </FormControl>
      {files.length > 0 && (
        <Alert
          color="success"
          variant="standard"
          onClose={onRemove}
          sx={{py: 0.5}}>
          {files.length} file{files.length > 1 ? 's' : ''} uploaded.
        </Alert>
      )}
    </Box>
  );
}

UploadButton.propTypes = {
  children: PropTypes.node.isRequired,
  errorMessage: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.shape({})),
  name: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  onUpload: PropTypes.func.isRequired,
  helperText: PropTypes.string,
};

UploadButton.defaultProps = {
  errorMessage: undefined,
  files: [],
  helperText: undefined,
  onRemove: undefined,
};

export default UploadButton;
